// ------------------------------------
// Dropzone (Upload de múltiplas imagens)
// ------------------------------------
(function () {
  'use strict';

  // Desabilita a inicialização automática do plugin
  Dropzone.autoDiscover = false;

  if ($('#dropzone').length > 0 && $('.form-produtos').length > 0) {
    // Variáveis
    let dropzoneObj;
    let imagesList = [];
    let totalImages = 0;
    const $dropzone = $('#dropzone');
    const dzUrl = $dropzone.data('dz-url');
    //const $dzBtnUpload = $('#dz-btn');
    const $dzMessageError = $('#dz-error');
    const $dzWrapper = $('.dz-wrapper');
    const $dzGallery = $('#dz-gallery');
    const $dzGalleryVariantes = $('#dz-gallery-variantes');
    const $dzGalleryKits = $('#dz-gallery-kit');
    const dzToken = $('#dz_token').val();
    const dzParam = $dropzone.data('dz-param') ? $dropzone.data('dz-param') : 'fotos';
    const dzMaxSize = $dropzone.data('dz-maxsize') ? parseInt($dropzone.data('dz-maxsize')) : 10;
    let dzMaxFiles = $dropzone.data('dz-maxfiles') !== undefined ? parseInt($dropzone.data('dz-maxfiles')) : 15;
    dzMaxFiles = dzMaxFiles <= 15 ? dzMaxFiles : 15;
    let dzRequired = $dropzone.data('dz-required') !== undefined;
    const dzAcao = $('.form-produtos input[name="acao"]').val();
    const $dzOrdem = $('#dz_ordem');
    const $dzRemovidas = $('#dz_removidas');
    const $dzInfos = $('#dz_fotos_infos');

    // Placeholder
    const dzPlaceholder = `
    <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd" stroke="#14a67a" stroke-linecap="round" stroke-linejoin="round" transform="translate(3 3)">
        <path d="m10.326 1.666.016 5.641-5.673.016" transform="matrix(.70710678 -.70710678 -.70710678 -.70710678 5.376348 12.979652)"/>
        <path d="m7.522.521v11.979"/>
        <path d="m.5 9v4.5c0 1.1045695.8954305 2 2 2h10c1.1045695 0 2-.8954305 2-2v-4.5"/>
      </g>
    </svg>
    <div>
      Adicionar Imagens
      <small>Arraste e solte ou clique para adicionar imagens</small>
    </div>`;

    // Configurações do Dropzone
    const dropzoneCfg = {
      url: dzUrl, // Url de ação do formulário
      dictDefaultMessage: dzPlaceholder, // Mensagem padrão interna no bloco
      paramName: dzParam, // Nome do parâmetro do campo
      maxFilesize: dzMaxSize, // Tamanho máximo da imagem (MB)
      maxFiles: dzMaxFiles, // Limite de imagens adicionadas por vez
      autoProcessQueue: true, // Habilita/Desabilita o processamento automático do upload
      addRemoveLinks: true, // Habilita o botão de remover no preview
      uploadMultiple: true, // Habilita o upload múltiplo
      parallelUploads: 15, // Limite máximo de imagens processadas paralelamente
      //dictRemoveFile: 'Remover', // Texto do botão de remover no preview
      dictRemoveFile: '×', // Texto do botão de remover no preview
      dictCancelUpload: '×',
      dictCancelUploadConfirmation: '×',
      acceptedFiles: '.jpg,.jpeg,.png,.webp', // Tipo de arquivos válidos
      timeout: 90000, // Tempo limite de processando das imagens
      dictFileTooBig: `As imagens não devem ser maiores que ${dzMaxSize} MB.`, // Mensagem do limite de tamanho
      dictInvalidFileType: 'Tipo de imagem inválida.', // Mensagem para as imagens inválidas
      dictMaxFilesExceeded: `Adicione no máximo ${dzMaxFiles} imagem(s)`, // Mensagem para o limite de imagens
      dictResponseError: 'server_error', // Parâmetro retornado quando ocorre um erro no servidor
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      // Quando o plugin é iniciado
      init: function () {
        verifyMaxFiles(this);
      },
    };

    // Inicializa o plugin
    function initDzGallery() {
      dropzoneObj = new Dropzone($dropzone[0], dropzoneCfg);
      if (dzAcao == 'update') {
        getImages();
      }
    }
    initDzGallery();

    // Inicializa o plugin SortableJS
    const sortableGallery = new Sortable($dzGallery[0], {
      animation: 150,
      forceFallback: true,
      onStart: function () {
        $('body').addClass('grabbing');
      },
      onEnd: function () {
        $('body').removeClass('grabbing');
      },
      onUpdate: function (ev) {
        saveOrder();
      },
    });

    // Evento quando um arquivo é adicionado
    dropzoneObj.on('addedfile', function () {
      hideMessageError();
      //$dzBtnUpload.show();
    });

    // Evento quando um arquivo é removido
    dropzoneObj.on('removedfile', function () {
      hideMessageError();
      if (dropzoneObj.files.length === 0) {
        //$dzBtnUpload.hide();
      }
    });

    // Evento executado enquanto o envio é processado
    dropzoneObj.on('sendingmultiple', function (file, xhr, formData) {
      $dzWrapper.addClass('disabled');
      //$dzBtnUpload.prop('disabled', true).html('<div class="btn-spinner dark"></div> Enviando');
      showLoader();
      // Demais campos
      formData.append('dz_acao', 'upload');
      if (dzAcao == 'insert') {
        formData.append('token_cad', dzToken);
      }
      if (dzAcao == 'update') {
        const prodID = $('input[name="id_update"]').val();
        formData.append('product_id', prodID);
      }
    });

    // Evento quando o formulário (arquivos) é processado com sucesso
    dropzoneObj.on('successmultiple', function (files, resp) {
      console.log(resp);
      try {
        resp = JSON.parse(resp);
        if (resp.status == 'success') {
          const numFiles = dropzoneObj.files.length;
          dzMaxFiles -= numFiles;
          updateMaxFiles();
          dropzoneObj.removeAllFiles(true);
          //$dzBtnUpload.hide();
          getImages(function () {
            hideLoader();
            const msg = numFiles > 1 ? 'Imagens adicionadas com sucesso.' : 'Imagem adicionada com sucesso.';
            Toast.fire({
              type: 'success',
              title: msg,
            });
          });
        } else {
          console.log(resp.mensagem);
          hideLoader();
          showMessageError(
            'Ocorreu um problema ao enviar. Por favor, verifique o formato ou tamanho das imagens e tente novamente.',
          );
        }
      } catch (error) {
        console.log(error);
        hideLoader();
        showMessageError(
          'Ocorreu um problema ao enviar. Por favor, verifique o formato ou tamanho das imagens e tente novamente.',
        );
      }
      resetDropzone();
    });

    // Quando um erro é retornado
    dropzoneObj.on('error', function (file, error) {
      console.log(error);
      hideLoader();
      dropzoneObj.removeFile(file);
      if (error == 'server_error') {
        showMessageError(
          'Ocorreu um problema ao enviar. Por favor, verifique o formato ou tamanho das imagens e tente novamente.',
        );
      } else {
        showMessageError(error);
      }
      resetDropzone();
    });

    // Envia o formulário
    /* $dzBtnUpload.on('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();

      // Verifica se algum arquivo foi adicionado
      if (dropzoneObj.files.length > 0) {
        dropzoneObj.processQueue();
      } else if (dzRequired) {
        showMessageError('É necessário adicionar pelo menos uma imagem.');
      }
    }); */

    // Evento ao clicar para remover uma imagem
    $dzGallery.on('click', '.img-mng-remove', function (ev) {
      ev.preventDefault();
      const imageID = $(this).data('id');
      removeImage(imageID);
      // Exibe a confirmação para remoção
      /* showConfirm(
        {
          type: 'danger',
          title: 'Remover Imagem',
          text: 'Deseja remover esta imagem?',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Remover',
          callback: function () {
            removeImage(imageID);
          },
        },
        true,
      ); */
    });

    // Reseta o dropzone
    function resetDropzone() {
      $dzWrapper.removeClass('disabled');
      //$dzBtnUpload.prop('disabled', false).html('<i class="las la-upload mr-2"></i>Enviar Imagens');
    }

    // Exibe uma mensagem de erro
    function showMessageError(error) {
      $dropzone.addClass('dropzone-error');
      $dzMessageError.html(error);
      $dzMessageError.show();
    }

    // Oculta a mensagem de erro
    function hideMessageError() {
      $dzMessageError.hide();
      $dropzone.removeClass('dropzone-error');
      $dzMessageError.html('');
    }

    // Desabilita o Dropzone (Oculta)
    function disableDropzone(instance) {
      instance.disable();
      $dzWrapper.addClass('disabled');
      $dzWrapper.hide();
    }

    // Habilita o Dropzone (Exibe)
    function enableDropzone(instance) {
      instance.enable();
      $dzWrapper.removeClass('disabled');
      $dzWrapper.show();
    }

    // Atualiza limite de arquivos
    function updateMaxFiles() {
      //dzMaxFiles = dzMaxFiles <= 15 ? dzMaxFiles : 15;
      dropzoneObj.options.maxFiles = dzMaxFiles;
      dropzoneObj.options.dictMaxFilesExceeded = `Adicione no máximo ${dzMaxFiles} imagem(s)`;
      $dropzone.attr('data-dz-maxfiles', dzMaxFiles);
      verifyMaxFiles(dropzoneObj);
    }

    // Verifica o limite de arquivos e atualiza o Dropzone
    function verifyMaxFiles(instance) {
      // Desativa o Dropzone se o limite de imagens for atingido
      if (dzMaxFiles <= 0) {
        dzRequired = false;
        disableDropzone(instance);
      } else {
        enableDropzone(instance);
      }
    }

    // Obtém a lista de imagens
    function getImages(cb) {
      let url = dzUrl + '?acao=dz_view';
      if (dzAcao == 'insert') {
        url += '&token_cad=' + dzToken;
      }
      if (dzAcao == 'update') {
        const prodID = $('input[name="id_update"]').val();
        url += '&product_id=' + prodID;
      }
      $.ajax({
        url: url,
        type: 'GET',
        contentType: 'application/json',
        cache: false,
      })
        .done(function (resp) {
          //console.log(resp);
          try {
            resp = JSON.parse(resp);
            imagesList = resp.images;
            totalImages = imagesList.length;
            removeImagesList();
            populateGallery(cb);
            populateGalleryVariantes();
            populateGalleryKits();
          } catch (error) {
            console.log(error);
          }
        })
        .fail(function (resp) {
          console.log(resp);
        });
    }

    // Atualiza as informações da galeria
    function updateGalleryInfos() {
      if (totalImages > 0) {
        $dzGallery.removeClass('d-none');
      } else {
        $dzGallery.addClass('d-none');
      }
      saveOrder();
    }

    // Popula galeria
    function populateGallery(cb) {
      $dzGallery.html('');
      if (totalImages > 0) {
        for (let i = 0, n = totalImages; i < n; i++) {
          const image = imagesList[i];
          const $image = `
          <div class="col-6 col-md-3 img-mng-wrapper" data-id="${image.id}">
            <div class="img-mng">
              <figure class="img"><img src="${image.image_small}"></figure>
              <a href="#" class="img-mng-remove" data-id="${image.id}">×</a>
            </div>
          </div>
          `;
          $dzGallery.append($image);
        }
      }
      updateGalleryInfos();
      //initTooltips();
      if (cb) {
        cb();
      }
    }

    // Popula galeria para seleção das variantes
    function populateGalleryVariantes() {
      $dzGalleryVariantes.html('');
      if (totalImages > 0) {
        for (let i = 0, n = totalImages; i < n; i++) {
          const image = imagesList[i];
          const $image = `
          <label class="col-6 col-md-3 img-check">
            <input type="radio" name="variant_img" value="${image.id}">
            <img src="${image.image_small}" class="img-fluid rounded">
          </label>`;
          $dzGalleryVariantes.append($image);
        }
      }
      $dzInfos.val(JSON.stringify(imagesList)).trigger('change');
    }

    // Popula galeria para seleção dos kits
    function populateGalleryKits() {
      $dzGalleryKits.html('');
      if (totalImages > 0) {
        for (let i = 0, n = totalImages; i < n; i++) {
          const image = imagesList[i];
          const $image = `
          <label class="col-6 col-md-3 img-check">
            <input type="radio" name="kit_img" value="${image.id}">
            <img src="${image.image_small}" class="img-fluid rounded">
          </label>`;
          $dzGalleryKits.append($image);
        }
      }
      $dzInfos.val(JSON.stringify(imagesList)).trigger('change');
    }

    // Remove uma imagem da lista
    function removeImage(imageID) {
      if ($dzRemovidas.val() != '') {
        $dzRemovidas.val($dzRemovidas.val() + ',' + imageID);
      } else {
        $dzRemovidas.val(imageID);
      }
      const $image = $dzGallery.find('.img-mng-wrapper[data-id="' + imageID + '"]');
      $image.find('[data-toggle="tooltip"]').tooltip('hide');
      $image.remove();
      dzMaxFiles += 1;
      totalImages -= 1;
      updateMaxFiles();
      updateGalleryInfos();
    }

    // Remove as fotos já removidas da lista obtida
    function removeImagesList() {
      const removidasArr = $dzRemovidas.val().split(',');
      imagesList = imagesList.filter((item) => removidasArr.indexOf(item.id) === -1);
      totalImages = imagesList.length;
    }

    // Salva a ordem das fotos
    function saveOrder() {
      let order = sortableGallery.toArray();
      order = order.map(function (item, index) {
        return {
          id: item,
          order: index + 1,
        };
      });
      //console.log(order);
      $dzOrdem.val(JSON.stringify(order));
    }
  }
})();
